export const GLOBAL_ROUTE_PREFIX =
    "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix";

const proxy = {
    Customer: `${GLOBAL_ROUTE_PREFIX}/master_data/customers/:id`,
    Account: `${GLOBAL_ROUTE_PREFIX}/master_data/accounts/:id`,
    Product: `${GLOBAL_ROUTE_PREFIX}/master_data/products/:id`,
    GeneralLedger: `${GLOBAL_ROUTE_PREFIX}/master_data/general_ledgers/:id`,
    TaxTableEntry: `${GLOBAL_ROUTE_PREFIX}/master_data/tax_table_entries/:id`,
    TaxTableEntryDetail: `${GLOBAL_ROUTE_PREFIX}/master_data/tax_table_entry_details/:id`,
    UomTableEntry: `${GLOBAL_ROUTE_PREFIX}/master_data/uom_table_entries/:id`,
    MovementType: `${GLOBAL_ROUTE_PREFIX}/master_data/movement_types/:id`,
    GeneralLedgerAccount: `${GLOBAL_ROUTE_PREFIX}/master_data/general_ledger_accounts/:id`,
    Owner: `${GLOBAL_ROUTE_PREFIX}/master_data/owners/:id`,
    AnalysisTypeTableEntry: `${GLOBAL_ROUTE_PREFIX}/master_data/analysis_type_table_entries/:id`,
    Asset: `${GLOBAL_ROUTE_PREFIX}/master_data/assets/:id`,
    Header: `${GLOBAL_ROUTE_PREFIX}/master_data/headers/:id`,
    Supplier: `${GLOBAL_ROUTE_PREFIX}/master_data/suppliers/:id`,
    PhysicalStock: `${GLOBAL_ROUTE_PREFIX}/master_data/physical_stocks/:id`,
    Journal: `${GLOBAL_ROUTE_PREFIX}/master_data/journals/:id`,
    Transaction: `${GLOBAL_ROUTE_PREFIX}/transactions/:id`,
    Invoice: `${GLOBAL_ROUTE_PREFIX}/sales_invoices/:id`,
    PurchaseInvoice: `${GLOBAL_ROUTE_PREFIX}/purchase_invoices/:id`,
    StockMovement: `${GLOBAL_ROUTE_PREFIX}/stock_movements/:id`,
    WorkDocument: `${GLOBAL_ROUTE_PREFIX}/work_documents/:id`,
    Payment: `${GLOBAL_ROUTE_PREFIX}/payments/:id`,
    Rule: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit/:modulePrefix/rules/:id`,
    AssetTransaction: `${GLOBAL_ROUTE_PREFIX}/asset_transactions/:id`,
    UOMTable: `${GLOBAL_ROUTE_PREFIX}/master_data/UOM_table/:id`,
    AnalysisTypeTable: `${GLOBAL_ROUTE_PREFIX}/master_data/analysis_type_table/:id`,
    AuditNavigation: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/nc_audit`,
    Customers: `${GLOBAL_ROUTE_PREFIX}/master_data/customers/:id`,
    Products: `${GLOBAL_ROUTE_PREFIX}/master_data/products/:id`,
    TaxTableEntries: `${GLOBAL_ROUTE_PREFIX}/master_data/tax_table_entries/:id`,
    TaxTableEntryDetails: `${GLOBAL_ROUTE_PREFIX}/master_data/tax_table_entry_details/:id`,
    UomTableEntries: `${GLOBAL_ROUTE_PREFIX}/master_data/uom_table_entries/:id`,
    MovementTypes: `${GLOBAL_ROUTE_PREFIX}/master_data/movement_types/:id`,
    GeneralLedgerAccounts: `${GLOBAL_ROUTE_PREFIX}/master_data/general_ledger_accounts/:id`,
    Owners: `${GLOBAL_ROUTE_PREFIX}/master_data/owners/:id`,
    AnalysisTypeTableEntries: `${GLOBAL_ROUTE_PREFIX}/master_data/analysis_type_table_entries/:id`,
    Assets: `${GLOBAL_ROUTE_PREFIX}/master_data/assets/:id`,
    Headers: `${GLOBAL_ROUTE_PREFIX}/master_data/headers/:id`,
    Suppliers: `${GLOBAL_ROUTE_PREFIX}/master_data/suppliers/:id`,
    PhysicalStocks: `${GLOBAL_ROUTE_PREFIX}/master_data/physical_stocks/:id`,
    Journals: `${GLOBAL_ROUTE_PREFIX}/master_data/journals/:id`,
    Transactions: `${GLOBAL_ROUTE_PREFIX}/transactions/:id`,
    SalesInvoices: `${GLOBAL_ROUTE_PREFIX}/sales_invoices/:id`,
    PurchasesInvoices: `${GLOBAL_ROUTE_PREFIX}/purchases_invoices/:id`,
    StockMovements: `${GLOBAL_ROUTE_PREFIX}/stock_movements/:id`,
    WorkDocuments: `${GLOBAL_ROUTE_PREFIX}/work_documents/:id`,
    Payments: `${GLOBAL_ROUTE_PREFIX}/payments/:id`,
    AssetTransactions: `${GLOBAL_ROUTE_PREFIX}/asset_transactions/:id`,
    UOMTables: `${GLOBAL_ROUTE_PREFIX}/master_data/UOM_table/:id`,
    AnalysisTypeTables: `${GLOBAL_ROUTE_PREFIX}/master_data/analysis_type_table/:id`,
    MovementTypeTable: `${GLOBAL_ROUTE_PREFIX}/master_data/movement_type_table/:id`,
    Withholding: `${GLOBAL_ROUTE_PREFIX}/withholding/:id`,
    WithholdingLines: `${GLOBAL_ROUTE_PREFIX}/withholding/:id`,
    WithholdingTax: `${GLOBAL_ROUTE_PREFIX}/withholding_tax/:id`,
    IncomeTax: `${GLOBAL_ROUTE_PREFIX}/income_tax/:id`,
    ChartOfAccounts: `${GLOBAL_ROUTE_PREFIX}/master_data/chart_of_accounts/:id`,
    AccountLedger: `${GLOBAL_ROUTE_PREFIX}/account_ledger/:id`,
    SupportDocs: `${GLOBAL_ROUTE_PREFIX}/support_docs/:id`,
    AccountsReportLines: `${GLOBAL_ROUTE_PREFIX}/accounts_report_lines/:id`,
    Employee: `${GLOBAL_ROUTE_PREFIX}/employee/:id`,
    Employees: `${GLOBAL_ROUTE_PREFIX}/master_data/employee/:id`,
};

export default proxy;
